import type {SyncRoutes, RerouterLocation} from './types';

import * as React from 'react';
import {matchSync, resolveSyncPath} from './path';
import {RouteContext, type RouteContextValue} from './route-context';
import {useHistory} from './hooks';


export function useRoutes(
  routes: SyncRoutes,
): [React.ReactNode, RouteContextValue, RerouterLocation] {
  const history = useHistory();
  const {location} = history;
  const parent = React.useContext(RouteContext);

  const parentPathname = parent.pathname ?? '';
  const pathname = (location.pathname ?? '').slice(parentPathname.length);

  const contextValue = React.useMemo(() => {
    const path = matchSync(routes, pathname, parentPathname);
    const localContext = resolveSyncPath(path);
    return {
      pathname: parentPathname + localContext.pathname,
      params: {...(parent.params ?? {}), ...localContext.params},
      path,
    };
  }, [routes, pathname, parentPathname, parent.params]);

  return [
    <RouteContext.Provider value={contextValue}>
      {/* @ts-expect-error - TS2322 - Type '{ part: string | null | undefined; pathname: string; parentPathname: string; route: SyncRoute; params: Readonly<{ [key: string]: string; }>; }' is not assignable to type 'ReactNode'. */}
      {contextValue.path.reduceRight(
        (children, {route, pathname, parentPathname}) =>
          // @ts-expect-error - TS2769 - No overload matches this call.
          route.element
            ? typeof route.element === 'function'
              ? route.element({
                  params: contextValue.params,
                  pathPart: pathname,
                  pathname: parentPathname + pathname,
                  location,
                  history,
                  children,
                })
              : route.element
            : children,
        null,
      )}
    </RouteContext.Provider>,
    contextValue,
    location,
  ];
}
